import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-team-name',
  templateUrl: './team-name.component.html',
  styleUrls: ['./team-name.component.scss']
})
export class TeamNameComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
